/** biome-ignore-all lint/suspicious/noEmptyBlockStatements: disabled */

import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

/** Bump when onboarding content changes so all users see it again. */
const PHOTO_ONBOARDING_STORAGE_KEY = "photo-onboarding-storage-v3";

type PhotoOnboardingState = {
	/** Persistido: true após completar o onboarding no fluxo inicial */
	hasCompletedInitialOnboarding: boolean;

	/** Visibilidade do onboarding no fluxo inicial ("Tirar foto") */
	isVisibleForInitialFlow: boolean;

	/** Visibilidade do onboarding no fluxo de orientação (HelpCircle) */
	isVisibleForOrientation: boolean;

	/** Clique no botão principal — mostra apenas se ainda não completou */
	openForInitialFlow: () => void;

	/** Clique no ícone de orientação — sempre mostra */
	openForOrientation: () => void;

	/** Fecha o onboarding (usado em ambos os fluxos) */
	closeOnboarding: () => void;

	/** Marca como concluído o fluxo inicial (chamado no botão "Entendi") */
	completeInitialOnboarding: () => void;
};

export const usePhotoOnboardingStore = create<PhotoOnboardingState>()(
	persist(
		(set, get) => ({
			hasCompletedInitialOnboarding: false,
			isVisibleForInitialFlow: false,
			isVisibleForOrientation: false,
			openForInitialFlow: () => {
				const { hasCompletedInitialOnboarding } = get();
				if (!hasCompletedInitialOnboarding) {
					set({ isVisibleForInitialFlow: true });
				}
			},
			openForOrientation: () => {
				set({ isVisibleForOrientation: true });
			},
			closeOnboarding: () => {
				set({
					isVisibleForInitialFlow: false,
					isVisibleForOrientation: false,
				});
			},
			completeInitialOnboarding: () => {
				set({
					hasCompletedInitialOnboarding: true,
					isVisibleForInitialFlow: false,
					isVisibleForOrientation: false,
				});
			},
		}),
		{
			name: PHOTO_ONBOARDING_STORAGE_KEY,
			storage: createJSONStorage(() => {
				if (typeof window === "undefined") {
					return {
						getItem: () => null,
						setItem: () => {},
						removeItem: () => {},
					};
				}
				return localStorage;
			}),
			partialize: (state) => ({
				hasCompletedInitialOnboarding: state.hasCompletedInitialOnboarding,
			}),
		}
	)
);
